import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { canAccess } from "@/lib/rbac";

export default function PrivateRoute({ children, menu, roles }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen grid place-items-center bg-[#f7f9f7]">
        <div className="text-sm text-slate-500">Memuat sesi...</div>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;

  // Menu-based RBAC (preferred)
  if (menu && !canAccess(user.role, menu)) {
    return (
      <div className="p-8 text-center text-slate-500" data-testid="access-denied">
        Anda tidak memiliki akses ke halaman ini.
      </div>
    );
  }

  // Legacy role list check (kept for backwards compat)
  if (roles && !roles.includes(user.role) && user.role !== "admin") {
    return (
      <div className="p-8 text-center text-slate-500">Anda tidak memiliki akses ke halaman ini.</div>
    );
  }
  return children;
}
